import { useFetch } from "@/common/hooks/useFetch";
import { apiAds } from "@/common/services";
import { useAdSlotsStore } from "@/common/store/adSlotsStore";
import { useCallback, useEffect } from "react";

export const useGetAdSlots = () => {
  const slots = useAdSlotsStore((state) => state.slots);
  const setSlots = useAdSlotsStore((state) => state.setSlots);

  const fetchSlots = useCallback(() => apiAds.getAdSlots(), []);
  const { isLoading, error, data } = useFetch(fetchSlots, slots === null);

  useEffect(() => {
    if (!error && data) {
      setSlots(data.slots);
    }
  }, [error, data, setSlots]);

  return {
    slots,
    isLoading,
    error,
  };
};
